import { render } from "./index.vue?vue&type=template&id=093f1f56"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\代码\\frontend\\hongkong-puzzle-h5-web\\web\\node_modules\\_vue-loader@17.0.0@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__